<div [class.isDetailRoute]="isDetailRoute" class="navbar-mobile">
  <button class="text-btn-16" (click)="toggleCollapse()" nz-button nzShape="circle" nzType="default">
    <app-st-icon name="menu"></app-st-icon>
  </button>

  <h1 class="text-header-24">{{currentRouteLabel}}</h1>
</div>

@if (!isCollapsed) {
<div (click)="toggleCollapse()" class="shadow-bg">
  <button nz-button nzType="primary" nzShape="circle">
    <app-st-icon name="close"></app-st-icon>
  </button>
</div>
}

<nz-sider
  nzCollapsible
  [(nzCollapsed)]="isCollapsed"
  [nzTrigger]="null"
  [nzCollapsedWidth]="(isMobile$ | async) ? 0 : 64" style="padding: 16px 8px">
  <!-- Logo -->
  <div class="logo" (click)="toggleCollapse()">
    @if (!isCollapsed) {
      <span class="text-header-24">sourtrack</span>
    }
    @if (!(isMobile$ | async)) {
      <app-st-icon [name]="!isCollapsed ? 'left_panel_close' : 'right_panel_close'"></app-st-icon>
    }
  </div>
  <!-- Sociedades -->
  <div
    nz-dropdown
    [nzTrigger]="'click'"
    [nzOverlayStyle]="{ minWidth: '200px' }"
    [nzClickHide]="true"
    [nzDropdownMenu]="menu"
  >
    <div class="company-selector">
      <nz-avatar [nzText]="selectedCompanyInitials"></nz-avatar>
      @if (!isCollapsed) {
        <span>{{ selectedCompany?.name }}</span>
        <app-st-icon name="keyboard_arrow_down"></app-st-icon>
      }
    </div>
  </div>
  <!-- Dropdown Menu -->
  <nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu>
      @for (company of loggedUser?.companies; track company) {
        <li
          nz-menu-item
          [class.selected]="company.id === selectedCompany?.id"
          (click)="selectCompany(company)"
        >
          {{ company.name }}
        </li>
      }
    </ul>
  </nz-dropdown-menu>
  <!-- Menú principal -->
  <ul nz-menu nzMode="inline" style="margin-bottom: 70px" [nzInlineCollapsed]="isCollapsed">
    @for (item of menuItems; track item) {
      @if (item.icon) {
        @if (loggedUser?.viewAdministracion || item.label !== 'Administración') {
          <li
              [nz-tooltip]="isCollapsed ? item.label : null" nzTooltipPlacement="right"
              nz-menu-item
              [routerLink]="['/' + item.route]"
              routerLinkActive="ant-menu-item-selected"
          >
  <!--          [nzColor]="'#0068D6'"-->
            <div style="display: flex">
              @if (item.label === 'Notificaciones' && isCollapsed){
                <nz-badge [nzDot]="inboxNotification>0" [nzOffset]="[1, 9]" [nzStyle]="{ backgroundColor: '#EA3E83'}">
                  <app-st-icon [color]="item.color" [name]="item.icon"></app-st-icon>
                </nz-badge>
              }@else{<app-st-icon [color]="item.color" [name]="item.icon"></app-st-icon>}
            @if (!isCollapsed) {
              <span style="flex-grow: 1">{{ item.label }}</span>
            }
            <!-- Badge para menú expandido -->
            @if (item.label === 'Notificaciones' && !isCollapsed && inboxNotification > 0) {
              <nz-badge nzStandalone [nzStyle]="{ backgroundColor: '#EBF5FF', color:'#0068D6',fontSize:'10px',fontWeight:'600' }"
                        [nzCount]="inboxNotification" style="margin: auto;"></nz-badge>
            }</div>
          </li>
        }
      }
    }
    <!-- Menú de Maestros - Versión expandida -->
    @if (!isCollapsed) {
      @if (canViewMaestrosMenu()) {
        <li nz-submenu [nzTitle]="titleTpl"
            [nzTriggerSubMenuAction]="'click'" nzPlacement="bottomRight">
          <ng-template #titleTpl>
            <app-st-icon [color]="'#12A594'" [name]="'design_services'"></app-st-icon>
            <span>Maestros</span>
          </ng-template>
          <ul [class.max-height-500]="isCollapsed">
            @for(group of groupedMaestrosSubmenuItems; track $index){
              @for (item of group; track item) {
                @if (canViewMaestroItem(item)) {
                  <li nz-menu-item [routerLink]="['/maestro/' + item.route]"
                      routerLinkActive="ant-menu-item-selected">
                    <span>{{ item.label }}</span>
                  </li>
                }
              }
              @if (!$last && loggedUser?.viewMaestros){
                <li nz-menu-divider [style.margin]="'0 15px'"></li>
              }
            }
          </ul>
        </li>
      }
    }

    <!-- Menú de Maestros - Versión colapsada (Dropdown) -->
    @if (isCollapsed) {
      @if (canViewMaestrosMenu()) {
        <li
            nz-dropdown
            [nzTrigger]="'click'"
            [nzOverlayStyle]="{ minWidth: '200px'}"
            [nzClickHide]="true"
            [nzDropdownMenu]="maestrosMenu"
            nzPlacement="topRight"
            [nz-tooltip]="'Maestros'" nzTooltipPlacement="right"
            class="ant-menu-item maestros-dropdown">
          <div class="maestros-selector">
            <app-st-icon [color]="'#12A594'" [name]="'design_services'"></app-st-icon>
          </div>
        </li>
      }
      <nz-dropdown-menu #maestrosMenu="nzDropdownMenu">
        <ul nz-menu [style.left]="'25%'" [style.bottom]="'5%'" class="custom-dropdown-scroll">
          @for(group of groupedMaestrosSubmenuItems; track $index){
            @for (item of group; track item) {
              @if (canViewMaestroItem(item)) {
                <li nz-menu-item [routerLink]="['/maestro/' + item.route]"
                    routerLinkActive="ant-menu-item-selected" class="maestro-dropdown">
                  <span>{{ item.label }}</span>
                </li>
              }
            }
            @if (!$last && loggedUser?.viewMaestros){
              <li nz-menu-divider [style.margin]="'12px 0px'"></li>
            }
          }
        </ul>
      </nz-dropdown-menu>
    }
  </ul>
  <!-- Elementos adicionales abajo -->
  <div class="sidebar-footer">
    <div nz-dropdown [nzTrigger]="'click'" [nzDropdownMenu]="userMenu" class="user-info" nzPlacement="topRight">
      <nz-avatar class="not-max-width"
                 [nzSrc]="getSafeImageUrl(loggedUser?.partner?.avatar)" [nzText]="loggedUserInitials"></nz-avatar>
      @if (!isCollapsed) {
        <div>
          <strong>{{loggedUser?.partner?.name}} {{loggedUser?.partner?.surName}}</strong>
          <span>{{loggedUser?.partner?.position}}</span>
        </div>
      }
    </div>

    <!-- Menú desplegable para Estados -->
    <nz-dropdown-menu #userMenu="nzDropdownMenu">
      <ul [style.left]="(isMobile$ | async) ? '0' : (isCollapsed ? '25%' : '100%')"
          [style.top]="isCollapsed?'30%':'0'" nz-menu>
        <li nz-menu-item (click)="logout()">
          <app-st-icon [bold]="true" name="logout"></app-st-icon>
          Cerrar sesión
        </li>
      </ul>
    </nz-dropdown-menu>
<!--    <ul nz-menu>-->
<!--      <li class="settings" [routerLink]="'/configuration'" routerLinkActive="ant-menu-item-selected">-->
<!--        <app-st-icon name="settings"></app-st-icon>-->
<!--        <span *ngIf="!isCollapsed">Configuración</span>-->
<!--      </li>-->
<!--    </ul>-->
  </div>
</nz-sider>
